export type ProductConfigGroup = 'foam' | 'hardware'

export function assemblyTypeLabel(value: unknown): string {
  if (value === 'assembled') return 'Ráp chết'
  if (value === 'kd') return 'Tháo rời'
  return ''
}

export function istaLevelLabel(value: unknown): string {
  if (value === '1A') return 'Thường (1A)'
  if (value === '3A') return 'Ecom (3A)'
  return ''
}

export function productConfigLabel(
  group: ProductConfigGroup,
  config: { assembly_type?: unknown; packaging_type?: unknown; color?: unknown },
): string {
  const assembly = assemblyTypeLabel(config.assembly_type)
  if (group === 'foam') {
    const packagingCode = config.packaging_type === 'thuong' ? '1A' : config.packaging_type === 'ecom' ? '3A' : ''
    const packaging = istaLevelLabel(packagingCode)
    return [assembly, packaging].filter(Boolean).join(' - ')
  }
  const color = typeof config.color === 'string' ? config.color.trim() : ''
  return [color, assembly].filter(Boolean).join(' - ')
}
